import { Injectable } from "@angular/core";
import { InitialLoadAction } from "./initial-load-action";
import { LoadingService } from "./loading-service";
import { UiMessageService } from "../ui-message-broker/ui-message-broker.service";

/**
 * On app boot (after config + permissions have loaded), open the single
 * shared SSE EventSource. Mirrors bookwise-ui's init action.
 */
@Injectable({ providedIn: 'root' })
export class InitUIMessageBrokerAction extends InitialLoadAction<boolean> {

    constructor(loadingService: LoadingService,
                private uiMessageBrokerService: UiMessageService) {
        super('UIMessageBroker', loadingService);
    }

    override onLoad(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            this.uiMessageBrokerService.connect();
            resolve(true);
        });
    }
}
